<template>
	<div class="app-filter pa-0 mb-2 ml-4 mr-4">
		<app-expansion-panels :value="value ? 0 : null">
			<app-expansion-panel>
				<template v-slot:header>
					<div class="mb-2">
						<span class="subtitle">{{ label }}</span>
						<app-button
							:color="color"
							small
							outlined
							no-margin
							class="app-filter-action ml-2"
							@click.stop="onClick"
						>{{ actionLabel }}</app-button>
					</div>
				</template>
				<template v-slot:content>
					<slot />
				</template>
			</app-expansion-panel>
		</app-expansion-panels>
	</div>
</template>

<script>
export default {
	props: {
		value: Boolean,
		color: {
			type: String,
			default: 'primary',
		},
		label: {
			type: String,
			default: 'Filters',
		},
		actionLabel: {
			type: String,
			default: 'Apply',
		},
	},
	methods: {
		onClick(event) {
			this.$emit('click', event)
		},
	},
}
</script>

<style scoped>
	.app-filter >>> .v-expansion-panels .app-filter-action {
		visibility: hidden;
	}

	.app-filter >>> .v-expansion-panels > .v-expansion-panel--active .app-filter-action {
		visibility: visible;
	}
</style>
